var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 1C14.972 1.067 13.6483 1.70934 12.8613 2.52734C12.1503 3.27134 11.5894 4.37631 11.8184 5.44531C13.0714 5.47831 14.329 4.81933 15.082 3.98633C15.785 3.20733 16.318 2.12 16.125 1ZM16.1934 5.44336C14.3844 5.44336 13.628 6.55469 12.375 6.55469C11.086 6.55469 9.90766 5.51367 8.34766 5.51367C6.22566 5.51467 3 7.48033 3 12.1113C3 16.3243 6.81766 21 8.97266 21C10.2817 21.013 10.599 20.177 12.375 20.168C14.153 20.155 14.5367 21.011 15.8477 21C17.3237 20.989 18.4764 19.367 19.3184 18.082C19.9224 17.162 20.1707 16.6923 20.6387 15.6523C17.1657 14.7723 16.4747 9.17167 20.6387 8.01367C19.8527 6.67267 17.5584 5.44336 16.1934 5.44336Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.19fa45f93cfc275b3030acc8a3a748a1.svg";
export { ForwardRef as ReactComponent };